import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
// TODO: set up with access-control

export class SwitchComponent implements OnInit {
  @Input() label: string;
  @Input() allowUncheck: boolean = true;
  @Input() checked: boolean;
  @Input() inputId: string;
  @Output() checkedChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  toggle() {
    if (this.checked && !this.allowUncheck) return;
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

}
